import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, [
    _createVNode("path", { d: "M12.101 2.9a.5.5 0 01.378-.056l3.397.847a.5.5 0 01.37.573c2.365 1.107 4.125 2.93 4.815 4.983a.5.5 0 01-.82.52c-1.21-1.16-2.794-2.171-4.642-2.902l-.025.1a.5.5 0 01-.606.364l-.485-.12-.907 3.638a.5.5 0 01.364.606l-2.298 9.218a.5.5 0 01-.606.364L8.61 20.43a.5.5 0 01-.364-.606l2.298-9.218a.5.5 0 01.606-.364l.907-3.638-.485-.121a.5.5 0 01-.364-.607l.025-.1c-1.974-.222-3.847-.073-5.46.383a.5.5 0 01-.48-.844c1.572-1.488 3.982-2.272 6.59-2.14a.5.5 0 01.218-.274z" })
  ]))
}